import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a954fa06")

_pushScopeId("data-v-a954fa06")
const _hoisted_1 = { class: "redirect-buttons" }
const _hoisted_2 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "redirect-buttons__button"
}, "Логистика", -1)
_popScopeId()

import { useAuthorization } from '@/common/composable/useAuthorization'

export default _defineComponent({
  setup(__props) {

const authorization = useAuthorization()

const onRedirectToWMS = () => {
    if (!authorization.isAuthenticated) return

    const answer = confirm('Вы уверены что хотите перейти в WMS?')
    if (!answer) return

    const accessToken = authorization.authorizationState.access_token

    if (accessToken) {
        const redirectUrl = `${process.env.VUE_APP_REDIRECT_WMS_LINK}?token=${encodeURIComponent(
            accessToken
        )}`
        window.location.href = redirectUrl
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      type: "button",
      class: "redirect-buttons__button redirect-buttons__button-inactive",
      disabled: !_unref(authorization).isAuthenticated,
      onClick: onRedirectToWMS
    }, " Склад ", 8, ["disabled"]),
    _hoisted_2
  ]))
}
}

})